const config = {
  rowSelection: false,
  columns: [
    {
      title: '类型',
      dataIndex: 'whiteTypeName',
      width: 140,
      ellipsis: true
    },
    {
      title: '节点',
      dataIndex: 'nodeNameList',
      width: 200,
      ellipsis: true,
      render: 'nodeNameListName'
    },
    {
      title: '收款类型',
      dataIndex: 'receiptTypeNameList',
      width: 200,
      ellipsis: true,
      render: 'receiptTypeNameListName'
    },
    {
      title: '原因',
      dataIndex: 'remarks',
      width: 200,
      ellipsis: true
    },
    {
      title: '审批时间',
      dataIndex: 'auditTime',
      itemType: 'dateTime',
      width: 150,
    },
    {
      title: '审批状态',
      dataIndex: 'auditStateName',
      width: 120,
    },
    {title: '操作', dataIndex: '#', width: 100, fixed: 'right', render: 'actionRender'},
  ],
  search: [],
  footer: [{label: '新增', type: 'primary', auth: 'AddWhiteList', events: ['onClick:onAdd']},]
}
export default config
